import type { ReactNode } from "react";

type BannerVariant = "warning" | "error" | "success";

interface BannerProps {
  variant: BannerVariant;
  children: ReactNode;
  "data-testid"?: string;
}

const variantStyles: Record<BannerVariant, string> = {
  warning: "bg-warning-container border-warning text-warning",
  error: "bg-error-container border-error text-error",
  success: "bg-secondary-container border-on-secondary-container text-on-secondary-container",
};

export function Banner({ variant, children, "data-testid": testId }: BannerProps) {
  return (
    <div
      role="alert"
      data-testid={testId}
      className={`border-s-4 ps-3 pe-3 pbs-2 pbe-2 text-sm rounded-md ${variantStyles[variant]}`}
    >
      {children}
    </div>
  );
}
